"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@material-ui/core");

var styles_1 = require("@material-ui/core/styles");

var react_1 = __importDefault(require("react"));

var helpers_1 = require("../helpers");

var styles = function styles(theme) {
  return {
    formControl: {
      fontFamily: 'Omnes',
      margin: theme.spacing.unit,
      width: '100%'
    },
    root: {
      background: '#F1F2F2',
      borderRadius: '3px',
      display: 'flex',
      flexWrap: 'wrap',
      fontFamily: 'Omnes',
      height: '48px'
    }
  };
};

var ITEM_HEIGHT = 48;
var ITEM_PADDING_TOP = 8;
var MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

var BB8Select =
/** @class */
function (_super) {
  __extends(BB8Select, _super);

  function BB8Select() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      selected: []
    }; // @TODO: For the future, refactor this method in chunks

    _this.handleChange = function (event) {
      var selected = _this.state.selected; // tslint:disable-next-line:one-variable-per-declaration

      var target, unSelection, index;

      if (selected.length > event.target.value.length) {
        unSelection = helpers_1.diffArray(selected, event.target.value);
        target = unSelection[0];
      } else {
        target = event.target.value[event.target.value.length - 1];
      }

      index = selected.indexOf(target);

      if (target === 'All' || target === 'all') {
        if (index > -1) {
          var options = _this.props.items.filter(function (_a) {
            var value = _a.value;
            return value !== 'All' && value !== 'all';
          }).map(function (_a) {
            var value = _a.value;
            return value;
          });

          _this.setState({
            selected: options
          }, _this.props.handleChange(options));
        } else {
          _this.setState({
            selected: [target]
          }, _this.props.handleChange([target]));
        }

        return;
      }

      if (index > -1) {
        selected.splice(index, 1);

        _this.setState({
          selected: selected
        }, _this.props.handleChange(selected));
      } else {
        var options = selected.filter(function (item) {
          return item !== 'All' && item !== 'all';
        });
        var newSelection = options.concat(target);

        _this.setState({
          selected: newSelection
        }, _this.props.handleChange(newSelection));
      }
    };

    _this.renderValue = function (selected) {
      if (!selected) {
        return;
      }

      if (typeof selected === 'string' || typeof selected === 'number') {
        return selected.toString();
      }

      if (Array.isArray(selected)) {
        if (selected[0] && selected[0].toString().toLowerCase() === 'all') {
          return ['Show All'].join(', ');
        }

        return selected.join(', ');
      }

      return;
    };

    return _this;
  }

  BB8Select.prototype.componentWillMount = function () {
    this.setState({
      selected: this.state.selected.concat(this.props.items[0].value)
    });
  };

  BB8Select.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        id = _a.id,
        classes = _a.classes,
        items = _a.items;
    var selected = this.state.selected;
    return react_1.default.createElement("div", {
      className: classes.root
    }, react_1.default.createElement(core_1.FormControl, {
      className: classes.formControl
    }, react_1.default.createElement(core_1.Tooltip, {
      title: this.renderValue(selected),
      placement: "top"
    }, react_1.default.createElement(core_1.Select, {
      multiple: true,
      value: selected,
      onChange: this.handleChange,
      input: react_1.default.createElement(core_1.Input, {
        style: {
          fontFamily: 'Omnes'
        },
        id: id
      }),
      renderValue: this.renderValue,
      MenuProps: MenuProps,
      disableUnderline: true
    }, items.map(function (item) {
      return react_1.default.createElement(core_1.MenuItem, {
        id: item.key.toLowerCase().replace(' ', '-'),
        key: item.key,
        value: item.value
      }, react_1.default.createElement(core_1.Checkbox, {
        checked: _this.state.selected.indexOf(item.value) > -1
      }), react_1.default.createElement(core_1.ListItemText, {
        style: {
          fontFamily: 'Omnes'
        },
        disableTypography: true,
        primary: item.key
      }));
    })))));
  };

  return BB8Select;
}(react_1.default.Component);

exports.default = styles_1.withStyles(styles, {
  withTheme: true
})(BB8Select);